<template lang="pug">
    div.formGroup(:class="{'send': dirty}")
        label.label
            div.name {{name}}
            input.input(type='text', v-model.trim="data" @input="handleInput" @focus="onFocus()" @blur="onBlur()")
        span.msg
</template>

<script>
    export default {
        name: "Input",
        props: ['name', 'value'],
        data() {
            return {
                data: this.value,
                dirty: false,
                error: null,
            };
        },
        methods: {
            handleInput (e) {
                this.$emit('input', this.data)
            },
            onClick() {
                this.$refs['input'].focus();
            },
            onFocus() {
                this.dirty = true;
            },
            onBlur() {
                if (this.data === '') {
                    this.dirty = false;
                }
            }
        }
    }
</script>
